module.exports = __webpack_public_path__ + "static/Beliefs-bbb1fee42aed0c90a152c9650a9597c0.png";